import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {DialogRef} from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { Observable } from 'rxjs/Rx';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SharedService} from "../../shared/shared.service";
import {SettingsCashregService} from "./settings-cashreg.service";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";
import {DtoGiftCertificate} from "./models/DtoGiftCertificate";
import {DtoArticleBaseItems} from "./models/DtoArticleBaseItems";

@Component({
    selector: 'giftcertificate',
    template: require('./giftcertificate.component.html'),
    styles: [require('./giftcertificate.component.css')]
})
@AutoUnsubscribe()

export class GiftcertificateComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    form: FormGroup;
    dtoObject: DtoGiftCertificate;
    baseItems: DtoArticleBaseItems;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsCashregService,
                private ss: SharedService) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            description: ['', [SharedValidators.customRequired]],
            index: [null,[SharedValidators.customRequired]],
            isActive: null,
            giftAmount: null,
            departmentId: [null, [SharedValidators.customRequired]],
            cashregGroupId: null,
            cashregSubGroupId: null,
            variablePrice: null,
            employeeAdvice: null
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );

        if (this.id > 0) {
            this.ds.getGiftCertificateById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.getBaseItems();
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                });
        }
        else {
            this.ds.getGiftCertificateNextIndex()
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        index: res,
                        isActive: true,
                        giftAmount: 0,
                        variablePrice: true
                    };
                    this.getBaseItems();

                    if (this.copyFromId > 0) {
                        this.ds.getGiftCertificateById(this.copyFromId)
                            .subscribe(response => {
                                this.dtoObject.cashregGroupId = response.cashregGroupId;
                                this.dtoObject.cashregSubGroupId = response.cashregSubGroupId;
                                this.dtoObject.customerAdvice = response.customerAdvice;
                                this.dtoObject.departmentId = response.departmentId;
                                this.dtoObject.description = response.description;
                                this.dtoObject.isActive = response.isActive;
                                this.dtoObject.giftAmount = response.giftAmount;
                                this.dtoObject.employeeAdvice = response.employeeAdvice;
                                this.dtoObject.variablePrice = response.variablePrice;

                                this.fs.patchDtoToForm(this.dtoObject, this.form);
                            });
                    }
                    else {
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    }
                });
        }
    }

    getBaseItems() {
        this.ds.getArticleBaseItems(false).subscribe(response => {
            this.baseItems = response;
            if (this.dtoObject && this.dtoObject.id == 0) {
                if (this.baseItems.departments.length == 1) {
                    this.dtoObject.departmentId = this.baseItems.departments[0].id;
                }
            }
        });
    }

    getCashregSubGroups() {
        if (this.baseItems && this.form.get('cashregGroupId').value) {
            return this.baseItems.cashregGroups.find(x => x.id == this.form.get('cashregGroupId').value).cashregSubGroups;
        }
        return null;
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.ds.saveGiftCertificate(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/giftcertificate.component.ts